module.exports = __webpack_public_path__ + "static/media/icon-money.cbf10359.png";